import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import { reactive, getCurrentInstance, ref, defineComponent } from "vue";
import { setFormRequired } from "@ldos/shared-pc/src/util/miscUtils";
import AreaService, { Area } from "../api/AreaService";

export default /*#__PURE__*/_defineComponent({
  props: {
  terminal: {
    type: String,
    default: "",
  },
},
  setup(__props, { expose }) {

const props = __props

const validateArea = (rule: any, value: boolean, callback: any) => {
  if (value && state.form?.shopcount > 0) {
    callback(new Error("该区域下存在门店，请在门店管理修改后再禁用。"));
  } else {
    callback();
  }
};


const { proxy } = getCurrentInstance() as any;
// const areaService = new AreaService(props.terminal);
const state: any = reactive({
  dialog: false,
  title: "",
  mode: "add",
  form: {},
  ruleForm: {
    name: [{ required: true, message: "请输入区域名称", trigger: "blur" }],
    disabled: [{ required: true, message: "请选择区域状态", trigger: "change" }, { validator: validateArea, trigger: "change" }],
    tenantId: [{ required: true, message: "请选择租户", trigger: "blur" }],
  },
  storeStateList: [
    {
      value: false,
      label: "启用",
    },
    {
      value: true,
      label: "停用",
    },
  ],
});

const active = (res: Area) => {
  state.form = { ...res };
  state.title = res.id ? '编辑区域' : '新建区域';
  state.dialog = true;
};

const addStore = async (data: any) => {
  data.current = 1;
  // console.error('props.terminal',props.terminal)
  if (props.terminal === "ops") {
    var api = "/ops/area/add";
  } else {
    var api = "/mgr/area/add";
  }
  const [res] = await proxy.$api.post(api, data);
  proxy.$Message({
    type: "success",
    message: "新建成功",
  });
  state.dialog = false;
  proxy.$emit("optionSuccess", res);
};

const editStore = async (data: any) => {
  if (props.terminal === "ops") {
    var api = "/ops/area/edit";
  } else {
    var api = "/mgr/area/edit";
  }
  const [res] = await proxy.$api.post(api, data);
  proxy.$Message({
    type: "success",
    message: "编辑成功",
  });
  state.dialog = false;
  proxy.$emit("optionSuccess", res);
};


const confimForm = async (data: Area) => {
  // const upset = data.id ? areaService.edit : areaService.add;
  // const res = await upset(data)
  if (data.id) {
    editStore(data);
  } else {
    addStore(data);
  }
};

expose({
  active,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_mas_modal = _resolveComponent("mas-modal")!

  return (_openBlock(), _createBlock(_component_mas_modal, {
    visible: _unref(state).dialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).dialog) = $event)),
    customFooterBtns: "",
    closeIcon: "",
    width: "450px",
    title: _unref(state).title
  }, {
    content: _withCtx(() => [
      _createVNode(_component_mas_form_main, {
        labelPosition: "right",
        form: _unref(state).form,
        ruleForm: _unref(state).ruleForm,
        disabled: _unref(state).mode === 'detail' ? true : false,
        defaultFormFooter: _unref(state).mode === 'detail' ? false : true,
        defaultFormFooterButton: ['confirm', 'cancel'],
        onConfim: confimForm,
        labelWidth: "100px",
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).dialog = false))
      }, {
        content: _withCtx((slotProps) => [
          (__props.terminal === 'ops')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "租户",
                prop: "tenantId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: slotProps.content.tenantId,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.content.tenantId) = $event),
                    placeholder: "请选择租户",
                    style: {"width":"300px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pocket('TenantAll'), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "区域名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入区域名称",
                modelValue: slotProps.content.name,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.name) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "区域状态",
            prop: "disabled"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: slotProps.content.disabled,
                "onUpdate:modelValue": ($event: any) => ((slotProps.content.disabled) = $event),
                placeholder: "请选择区域状态",
                size: "large"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).storeStateList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["form", "ruleForm", "disabled", "defaultFormFooter"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})